import React from "react";
import { Reveal } from "./Reveal";
import { SPREADS } from "@/data";

export const Spreads = () => {
  return (
    <section id="spreads" data-testid="spreads-section" className="relative py-24 md:py-32">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-8 bg-sf-ember" />
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-sf-ember">The Spreads</span>
          </div>
          <h2 className="sf-stencil text-4xl md:text-5xl text-sf-bone max-w-3xl leading-[1.05]">
            4 tactical layouts. Every mission covered.
          </h2>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SPREADS.map((s, i) => (
            <Reveal key={s.name} delay={(i % 4) * 0.06}>
              <div
                data-testid="spread-card"
                className="group relative h-full bg-sf-surface border border-sf-border rounded-md p-6 overflow-hidden transition-colors hover:border-sf-steel/60"
              >
                <div className="absolute inset-0 sf-scanlines opacity-20 pointer-events-none" />
                <div className="flex items-center justify-between">
                  <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-sf-muted">
                    Spread {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-sf-steel border border-sf-steel/40 rounded-sm px-2 py-0.5">
                    {s.cards}
                  </span>
                </div>
                <h3 className="mt-6 sf-stencil text-xl tracking-wide text-sf-bone">{s.name}</h3>
                <p className="mt-2 text-sm text-sf-dim leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Spreads;
